const ToolbarSkeletonLoader = () => {
  return (
    <div className="cy:max-w-7xl cy:mx-auto">
      {/* Main Card */}
      <div className="cy:bg-white cy:rounded-lg cy:shadow-sm">
        {/* Header */}
        <div className="cy:border-b cy:border-gray-200 cy:pb-6 cy:p-6">
          <div className="cy:h-6 cy:bg-gray-200 cy:rounded cy:w-56 cy:mb-2 cy:animate-pulse"></div>
          <div className="cy:h-4 cy:bg-gray-100 cy:rounded cy:w-full cy:max-w-2xl cy:animate-pulse"></div>
        </div>

        {/* Content */}
        <div className="cy:p-6">
          <div className="cy:grid cy:grid-cols-1 cy:md:grid-cols-2 cy:gap-8">
            {/* Left Column */}
            <div className="cy:space-y-6">
              {/* Master Toggle */}
              <div className="cy:flex cy:items-center cy:justify-between cy:pb-4 cy:border-b cy:border-gray-200">
                <div className="cy:h-5 cy:bg-gray-200 cy:rounded cy:w-40 cy:animate-pulse"></div>
                <div className="cy:h-6 cy:w-11 cy:bg-gray-200 cy:rounded-full cy:animate-pulse"></div>
              </div>

              {/* Features Section */}
              <div className="cy:space-y-4">
                <div className="cy:h-5 cy:bg-gray-200 cy:rounded cy:w-32 cy:mb-4 cy:animate-pulse"></div>
                
                {/* Feature Checkboxes */}
                {[...Array(4)].map((_, i) => (
                  <div key={i} className="cy:flex cy:items-center cy:space-x-3">
                    <div className="cy:w-4 cy:h-4 cy:bg-gray-200 cy:rounded cy:animate-pulse"></div>
                    <div className="cy:h-4 cy:bg-gray-200 cy:rounded cy:w-32 cy:animate-pulse"></div>
                  </div>
                ))}
              </div>

              {/* Toolbar Settings Section */}
              <div className="cy:pt-4 cy:border-t cy:border-gray-200 cy:space-y-4">
                <div className="cy:h-5 cy:bg-gray-200 cy:rounded cy:w-36 cy:mb-4 cy:animate-pulse"></div>
                
                {/* Font Size Select */}
                <div className="cy:space-y-2">
                  <div className="cy:h-4 cy:bg-gray-200 cy:rounded cy:w-32 cy:animate-pulse"></div>
                  <div className="cy:h-10 cy:bg-gray-200 cy:rounded cy:w-32 cy:animate-pulse"></div>
                </div>
              </div>

              {/* Placing Toolbar Section */}
              <div className="cy:p-4 cy:border cy:border-gray-200 cy:space-y-4">
                <div className="cy:h-5 cy:bg-gray-200 cy:rounded cy:w-36 cy:mb-4 cy:animate-pulse"></div>
                
                {/* Position Radio */}
                <div className="cy:space-y-3">
                  <div className="cy:h-4 cy:bg-gray-200 cy:rounded cy:w-24 cy:animate-pulse"></div>
                  <div className="cy:flex cy:space-x-4">
                    {[...Array(2)].map((_, i) => (
                      <div key={i} className="cy:flex cy:items-center cy:space-x-2">
                        <div className="cy:w-4 cy:h-4 cy:bg-gray-200 cy:rounded-full cy:animate-pulse"></div>
                        <div className="cy:h-4 cy:bg-gray-200 cy:rounded cy:w-12 cy:animate-pulse"></div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Vertical Offset Slider */}
                <div className="cy:space-y-3">
                  <div className="cy:flex cy:justify-between cy:items-center">
                    <div className="cy:h-4 cy:bg-gray-200 cy:rounded cy:w-28 cy:animate-pulse"></div>
                    <div className="cy:h-4 cy:bg-gray-200 cy:rounded cy:w-12 cy:animate-pulse"></div>
                  </div>
                  <div className="cy:h-2 cy:bg-gray-200 cy:rounded-full cy:w-full cy:animate-pulse"></div>
                </div>
              </div>

              {/* Save Button */}
              <div className="cy:pt-4">
                <div className="cy:h-10 cy:bg-gray-200 cy:rounded cy:w-32 cy:animate-pulse"></div>
              </div>
            </div>

            {/* Right Column - Preview */}
            <div className="cy:space-y-4">
              <div className="cy:h-5 cy:bg-gray-200 cy:rounded cy:w-24 cy:animate-pulse"></div>
              
              {/* Browser Preview */}
              <div className="cy:relative cy:bg-gray-100 cy:rounded-lg cy:p-4 cy:h-64">
                <div className="cy:absolute cy:top-4 cy:left-4 cy:right-4 cy:h-8 cy:bg-gray-200 cy:rounded cy:animate-pulse"></div>
                <div className="cy:absolute cy:top-16 cy:left-4 cy:right-4 cy:h-4 cy:bg-gray-200 cy:rounded cy:animate-pulse"></div>
                <div className="cy:absolute cy:top-24 cy:left-4 cy:right-4 cy:h-4 cy:bg-gray-200 cy:rounded cy:w-3/4 cy:animate-pulse"></div>
                
                {/* Toolbar Icon Preview */}
                <div className="cy:absolute cy:right-8 cy:w-10 cy:h-10 cy:bg-gray-300 cy:rounded-full cy:animate-pulse" 
                     style={{ top: '40%' }}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ToolbarSkeletonLoader;

